import { useEffect, useState } from "react";

import { DropDownMultiCheck } from "../../DropDownMultiCheck";

export default function SearchForm({
  searchObject,
  setSearchObject,
  onChange,
  searchConfig,
  t
}) {
  const [selected, setSelected] = useState([]);

  function onChangeSelectableFilters(selectedFilters) {
    let _searchObject = { ...searchObject };
    /// need to check if the selected filter is already in the searchObject
    let alreadySelected = selected.map((x) => x.id);
    selectedFilters.map((filter) => {
      if (!alreadySelected.includes(filter.id)) {
        if (filter.id === "languageId") {
          _searchObject["languageLevels"] = searchConfig.find(
            (x) => x.id === filter.id
          ).initial;
          _searchObject["languageLevels"] = searchConfig.find(
            (x) => x.id === filter.id
          ).initial;
        } else {
          _searchObject[filter.id] = searchConfig.find(
            (x) => x.id === filter.id
          ).initial;
        }
      }
    });
    setSearchObject(_searchObject);
  }
  function onRemoveSelected(filterName) {
    let _searchObject = { ...searchObject };
    delete _searchObject[filterName];
    setSearchObject(_searchObject);
  }
  useEffect(() => {
    let _selected = [];
    Object.keys(searchObject).map((key) => {
      let fieldConfig = null;
      //special case for languageLevels
      if (key === "languageLevels") {
        fieldConfig = searchConfig.find((x) => x.id === "languageId");
      } else if (key === "upperBoundSalary") {
        fieldConfig = searchConfig.find((x) => x.id === "lowerBoundSalary");
      } else if (key === "endingDate") {
        fieldConfig = searchConfig.find((x) => x.id === "startingDate");
      } else {
        fieldConfig = searchConfig.find((x) => x.id === key);
      }

      if (fieldConfig && _selected.indexOf(fieldConfig) === -1) {
        _selected.push(fieldConfig);
      }
    });
    _selected.sort((a, b) => a.type - b.type);
    setSelected(_selected);
  }, [searchObject]);

  return (
    <>
      <div className="row mb-5">
        {" "}
        <DropDownMultiCheck
          dataList={searchConfig}
          selecteds={selected}
          setSelecteds={onChangeSelectableFilters}
          isIdStringType={true}
          onRemoveSelected={onRemoveSelected}
        />
      </div>

      <div className="row">
        {selected.map((_fieldConfig, index) => {
          return _fieldConfig.Component(
            searchObject,
            setSearchObject,
            onChange,
            t
          );
        })}
      </div>
    </>
  );
}
